/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const GetSyncStatus = /* GraphQL */ `query GetSyncStatus {
  GetSyncStatus {
    statusCode
    data {
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSyncStatusQueryVariables,
  APITypes.GetSyncStatusQuery
>;
export const IsAuthorizedToAccessService = /* GraphQL */ `query IsAuthorizedToAccessService($input: IsAuthorizedRequest!) {
  IsAuthorizedToAccessService(input: $input) {
    isAuthorized
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsAuthorizedToAccessServiceQueryVariables,
  APITypes.IsAuthorizedToAccessServiceQuery
>;
export const GetDashboardEmbedUrl = /* GraphQL */ `query GetDashboardEmbedUrl($input: GetDashboardEmbedUrlRequest!) {
  GetDashboardEmbedUrl(input: $input) {
    url
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardEmbedUrlQueryVariables,
  APITypes.GetDashboardEmbedUrlQuery
>;
export const GetUserServiceAccess = /* GraphQL */ `query GetUserServiceAccess($input: GetUserServiceAccessRequest) {
  GetUserServiceAccess(input: $input) {
    services {
      name
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserServiceAccessQueryVariables,
  APITypes.GetUserServiceAccessQuery
>;
export const LoadFilterOptions = /* GraphQL */ `query LoadFilterOptions($input: GetLoadFilterOptionsRequest!) {
  LoadFilterOptions(input: $input) {
    filters
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LoadFilterOptionsQueryVariables,
  APITypes.LoadFilterOptionsQuery
>;
export const RetrieveView = /* GraphQL */ `query RetrieveView($input: GetRetrieveViewRequest!) {
  RetrieveView(input: $input) {
    viewData
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RetrieveViewQueryVariables,
  APITypes.RetrieveViewQuery
>;
export const LoadSavedViewsList = /* GraphQL */ `query LoadSavedViewsList($input: LoadSavedViewsListRequest!) {
  LoadSavedViewsList(input: $input) {
    Views {
      viewData
      __typename
    }
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LoadSavedViewsListQueryVariables,
  APITypes.LoadSavedViewsListQuery
>;
export const fetchReviews = /* GraphQL */ `query FetchReviews($input: FetchReviewsRequest!) {
  fetchReviews(input: $input) {
    reviews {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchReviewsQueryVariables,
  APITypes.FetchReviewsQuery
>;
export const fetchReviewsByUser = /* GraphQL */ `query FetchReviewsByUser($input: FetchReviewsByUserRequest!) {
  fetchReviewsByUser(input: $input) {
    reviewsRequestedByUser {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    reviewsToBeReviewedByUser {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchReviewsByUserQueryVariables,
  APITypes.FetchReviewsByUserQuery
>;
export const checkSystemPermission = /* GraphQL */ `query CheckSystemPermission($input: CheckSystemPermissionInput!) {
  checkSystemPermission(input: $input) {
    hasAccess
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckSystemPermissionQueryVariables,
  APITypes.CheckSystemPermissionQuery
>;
export const fetchReviewById = /* GraphQL */ `query FetchReviewById($input: FetchReviewByIdRequest!) {
  fetchReviewById(input: $input) {
    review {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchReviewByIdQueryVariables,
  APITypes.FetchReviewByIdQuery
>;
export const fetchAccessibleReviews = /* GraphQL */ `query FetchAccessibleReviews($input: FetchReviewsRequest) {
  fetchAccessibleReviews(input: $input) {
    reviews {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchAccessibleReviewsQueryVariables,
  APITypes.FetchAccessibleReviewsQuery
>;
export const createSIMTicket = /* GraphQL */ `query CreateSIMTicket($input: CreateSIMTicketRequest!) {
  createSIMTicket(input: $input) {
    ticketID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreateSIMTicketQueryVariables,
  APITypes.CreateSIMTicketQuery
>;
export const GetGroupsUserIsMemberOf = /* GraphQL */ `query GetGroupsUserIsMemberOf($userAlias: String!) {
  GetGroupsUserIsMemberOf(userAlias: $userAlias) {
    is_super_admin
    member_of_groups
    sandboxes_accessible {
      sandbox_id
      sandbox_name
      status
      allocation_types
      is_active
      created_at
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGroupsUserIsMemberOfQueryVariables,
  APITypes.GetGroupsUserIsMemberOfQuery
>;
export const ListSandboxWithAcl = /* GraphQL */ `query ListSandboxWithAcl($userAlias: String!) {
  ListSandboxWithAcl(userAlias: $userAlias) {
    is_super_admin
    member_of_groups
    sandboxes_accessible {
      sandbox_id
      sandbox_name
      status
      allocation_types
      is_active
      created_at
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSandboxWithAclQueryVariables,
  APITypes.ListSandboxWithAclQuery
>;
export const CheckAdminRole = /* GraphQL */ `query CheckAdminRole($userAlias: String!) {
  CheckAdminRole(userAlias: $userAlias) {
    is_admin
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckAdminRoleQueryVariables,
  APITypes.CheckAdminRoleQuery
>;
export const GetSandbox = /* GraphQL */ `query GetSandbox(
  $userAlias: String!
  $sandbox_id: String!
  $is_active: Boolean
) {
  GetSandbox(
    userAlias: $userAlias
    sandbox_id: $sandbox_id
    is_active: $is_active
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSandboxQueryVariables,
  APITypes.GetSandboxQuery
>;
export const ListSandboxes = /* GraphQL */ `query ListSandboxes(
  $userAlias: String!
  $is_active: Boolean
  $filter: TableSandboxFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListSandboxes(
    userAlias: $userAlias
    is_active: $is_active
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      created_at
      status
      sandbox_name
      allocation_types
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSandboxesQueryVariables,
  APITypes.ListSandboxesQuery
>;
export const GetInputContent = /* GraphQL */ `query GetInputContent(
  $sandbox_id: String!
  $input_id: String!
  $allocation_pool_filters: [String]
  $limit: Int
  $offset: Int
) {
  GetInputContent(
    sandbox_id: $sandbox_id
    input_id: $input_id
    allocation_pool_filters: $allocation_pool_filters
    limit: $limit
    offset: $offset
  ) {
    content
    last_modified
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInputContentQueryVariables,
  APITypes.GetInputContentQuery
>;
export const GetInputContentDownloadUrl = /* GraphQL */ `query GetInputContentDownloadUrl(
  $sandbox_id: String!
  $input_id: String!
  $allocation_pool_filters: [String]
  $user: String!
  $file_name: String!
) {
  GetInputContentDownloadUrl(
    sandbox_id: $sandbox_id
    input_id: $input_id
    allocation_pool_filters: $allocation_pool_filters
    user: $user
    file_name: $file_name
  ) {
    download_url
    error_msg
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInputContentDownloadUrlQueryVariables,
  APITypes.GetInputContentDownloadUrlQuery
>;
export const GetInputSchema = /* GraphQL */ `query GetInputSchema(
  $allocation_type: AllocationType!
  $input_type: InputType!
  $sandbox_id: String
  $input_id: String
) {
  GetInputSchema(
    allocation_type: $allocation_type
    input_type: $input_type
    sandbox_id: $sandbox_id
    input_id: $input_id
  ) {
    column_schema {
      name
      label
      type
      required
      defaultValue
      __typename
    }
    query_schema
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInputSchemaQueryVariables,
  APITypes.GetInputSchemaQuery
>;
export const ListInput = /* GraphQL */ `query ListInput(
  $sandbox_id: String!
  $is_active: Boolean
  $allocation_type: AllocationType
  $input_type: InputType
  $limit: Int
  $nextToken: String
) {
  ListInput(
    sandbox_id: $sandbox_id
    is_active: $is_active
    allocation_type: $allocation_type
    input_type: $input_type
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      created_at
      status
      input_type
      allocation_type
      s3_path
      userAlias
      dictionary_input_id
      source_id
      source_type
      configs
      sim_resource_key
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListInputQueryVariables, APITypes.ListInputQuery>;
export const GetAllocationConfigContent = /* GraphQL */ `query GetAllocationConfigContent(
  $allocation_type: AllocationType!
  $input_type: InputType!
  $sandbox_id: String
  $input_id: String
  $allocation_pool_filters: [String]
  $limit: Int
  $offset: Int
  $group_by: String
  $userAlias: String
) {
  GetAllocationConfigContent(
    allocation_type: $allocation_type
    input_type: $input_type
    sandbox_id: $sandbox_id
    input_id: $input_id
    allocation_pool_filters: $allocation_pool_filters
    limit: $limit
    offset: $offset
    group_by: $group_by
    userAlias: $userAlias
  ) {
    content
    last_modified
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllocationConfigContentQueryVariables,
  APITypes.GetAllocationConfigContentQuery
>;
export const GetAllocationConfigSchema = /* GraphQL */ `query GetAllocationConfigSchema(
  $allocation_type: AllocationType!
  $input_type: InputType!
  $sandbox_id: String
  $input_id: String
  $limit: Int
  $nextToken: String
) {
  GetAllocationConfigSchema(
    allocation_type: $allocation_type
    input_type: $input_type
    sandbox_id: $sandbox_id
    input_id: $input_id
    limit: $limit
    nextToken: $nextToken
  ) {
    column_schema {
      name
      label
      type
      required
      defaultValue
      __typename
    }
    query_schema
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllocationConfigSchemaQueryVariables,
  APITypes.GetAllocationConfigSchemaQuery
>;
export const ListInputDictionaryDiff = /* GraphQL */ `query ListInputDictionaryDiff(
  $sandbox_id: String!
  $input_id: String!
  $limit: Int
  $start: Int
  $use_dictionary_schema: Boolean
) {
  ListInputDictionaryDiff(
    sandbox_id: $sandbox_id
    input_id: $input_id
    limit: $limit
    start: $start
    use_dictionary_schema: $use_dictionary_schema
  ) {
    input_json
    input_schema {
      name
      label
      type
      required
      defaultValue
      __typename
    }
    total_input_count
    diff
    userAlias
    created_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInputDictionaryDiffQueryVariables,
  APITypes.ListInputDictionaryDiffQuery
>;
export const GetSimDetails = /* GraphQL */ `query GetSimDetails(
  $sandbox_id: String!
  $sim_id: String!
  $is_active: Boolean
  $is_shared: Boolean
) {
  GetSimDetails(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    is_active: $is_active
    is_shared: $is_shared
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    commentary_status
    commentary_run_url
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSimDetailsQueryVariables,
  APITypes.GetSimDetailsQuery
>;
export const ListSimsBySandbox = /* GraphQL */ `query ListSimsBySandbox(
  $sandbox_id: String!
  $is_active: Boolean
  $is_shared: Boolean
  $is_shared_by_me: Boolean
  $filter: SimBySandboxIdStatusFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListSimsBySandbox(
    sandbox_id: $sandbox_id
    is_active: $is_active
    is_shared: $is_shared
    is_shared_by_me: $is_shared_by_me
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      name
      status
      created_at
      updated_at
      started_at
      finished_at
      error_msg
      configs
      allocation_type
      input_ids
      mwaa_env
      dag_run_id
      scenario
      timeRange
      dag_tasks_status
      report_id
      is_shared
      userAlias
      created_by
      updated_by
      started_by
      is_input_selected
      published_to_fpaone
      fpaone_publish_status
      commentary_status
      commentary_run_url
      sandbox_name
      shared_to_sandbox_ids
      shared_from_sandbox_id
      shared_from_sandbox_name
      comments
      allocation_pools
      ticket_id
      simulation_tag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSimsBySandboxQueryVariables,
  APITypes.ListSimsBySandboxQuery
>;
export const ListAllSims = /* GraphQL */ `query ListAllSims(
  $is_active: Boolean
  $filter: SimBySandboxIdStatusFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListAllSims(
    is_active: $is_active
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      name
      status
      created_at
      updated_at
      started_at
      finished_at
      error_msg
      configs
      allocation_type
      input_ids
      mwaa_env
      dag_run_id
      scenario
      timeRange
      dag_tasks_status
      report_id
      is_shared
      userAlias
      created_by
      updated_by
      started_by
      is_input_selected
      published_to_fpaone
      fpaone_publish_status
      sandbox_name
      shared_to_sandbox_ids
      shared_from_sandbox_id
      shared_from_sandbox_name
      comments
      allocation_pools
      ticket_id
      simulation_tag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAllSimsQueryVariables,
  APITypes.ListAllSimsQuery
>;
export const ListSimsByStatusBySandbox = /* GraphQL */ `query ListSimsByStatusBySandbox(
  $sandbox_id: String!
  $is_active: Boolean
  $is_shared: Boolean
  $status: SimStatus!
  $filter: SimBySandboxIdStatusFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListSimsByStatusBySandbox(
    sandbox_id: $sandbox_id
    is_active: $is_active
    is_shared: $is_shared
    status: $status
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      name
      status
      created_at
      updated_at
      started_at
      finished_at
      error_msg
      configs
      allocation_type
      input_ids
      mwaa_env
      dag_run_id
      scenario
      timeRange
      dag_tasks_status
      report_id
      is_shared
      userAlias
      created_by
      updated_by
      started_by
      is_input_selected
      published_to_fpaone
      fpaone_publish_status
      sandbox_name
      shared_to_sandbox_ids
      shared_from_sandbox_id
      shared_from_sandbox_name
      comments
      allocation_pools
      ticket_id
      simulation_tag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSimsByStatusBySandboxQueryVariables,
  APITypes.ListSimsByStatusBySandboxQuery
>;
export const ListSimsByStatus = /* GraphQL */ `query ListSimsByStatus(
  $is_active: Boolean
  $status: SimStatus!
  $filter: SimBySandboxIdStatusFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListSimsByStatus(
    is_active: $is_active
    status: $status
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      name
      status
      created_at
      updated_at
      started_at
      finished_at
      error_msg
      configs
      allocation_type
      input_ids
      mwaa_env
      dag_run_id
      scenario
      timeRange
      dag_tasks_status
      report_id
      is_shared
      userAlias
      created_by
      updated_by
      started_by
      is_input_selected
      published_to_fpaone
      fpaone_publish_status
      sandbox_name
      shared_to_sandbox_ids
      shared_from_sandbox_id
      shared_from_sandbox_name
      comments
      allocation_pools
      ticket_id
      simulation_tag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSimsByStatusQueryVariables,
  APITypes.ListSimsByStatusQuery
>;
export const GetReportDetails = /* GraphQL */ `query GetReportDetails(
  $sandbox_id: String
  $report_id: String
  $sim_id: String
) {
  GetReportDetails(
    sandbox_id: $sandbox_id
    report_id: $report_id
    sim_id: $sim_id
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    status
    created_at
    sim_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReportDetailsQueryVariables,
  APITypes.GetReportDetailsQuery
>;
export const GetReportEmbedUrl = /* GraphQL */ `query GetReportEmbedUrl(
  $user_id: String!
  $sandbox_id: String!
  $sim_id: String!
  $allocation_type: AllocationType
  $is_shared: Boolean
) {
  GetReportEmbedUrl(
    user_id: $user_id
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    allocation_type: $allocation_type
    is_shared: $is_shared
  )
}
` as GeneratedQuery<
  APITypes.GetReportEmbedUrlQueryVariables,
  APITypes.GetReportEmbedUrlQuery
>;
export const GetSyncTimings = /* GraphQL */ `query GetSyncTimings($allocation_type: AllocationType) {
  GetSyncTimings(allocation_type: $allocation_type) {
    allocationDefinitionSyncTime
    allocationMappingSyncTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSyncTimingsQueryVariables,
  APITypes.GetSyncTimingsQuery
>;
export const GetConfigurations = /* GraphQL */ `query GetConfigurations($userAlias: String!, $configType: ConfigType) {
  GetConfigurations(userAlias: $userAlias, configType: $configType) {
    content
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConfigurationsQueryVariables,
  APITypes.GetConfigurationsQuery
>;
export const ListScenarios = /* GraphQL */ `query ListScenarios(
  $sandbox_id: String
  $allocation_type: AllocationType
  $is_active: Boolean!
  $is_enabled: Boolean!
  $filter: TableScenarioFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListScenarios(
    sandbox_id: $sandbox_id
    allocation_type: $allocation_type
    is_active: $is_active
    is_enabled: $is_enabled
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      scenario_name
      start_period
      end_period
      default_public
      created_at
      status
      status_key
      resource_key
      display_period
      resource_id
      sandbox_id
      allocation_type
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScenariosQueryVariables,
  APITypes.ListScenariosQuery
>;
export const ListOfCostpoolsInSimulation = /* GraphQL */ `query ListOfCostpoolsInSimulation(
  $sandbox_id: String!
  $sim_id: String!
  $driver_type: DriverType
) {
  ListOfCostpoolsInSimulation(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    driver_type: $driver_type
  ) {
    driver_type
    costpool_id
    costpool_name
    driver_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOfCostpoolsInSimulationQueryVariables,
  APITypes.ListOfCostpoolsInSimulationQuery
>;
export const ListOfDriversForImport = /* GraphQL */ `query ListOfDriversForImport(
  $sandbox_id: String!
  $sim_id: String!
  $costpool_ids: [String]
) {
  ListOfDriversForImport(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    costpool_ids: $costpool_ids
  ) {
    name
    created_time
    driver_id
    input_resource_key
    datasource_type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOfDriversForImportQueryVariables,
  APITypes.ListOfDriversForImportQuery
>;
export const ListOfDriverTimePeriod = /* GraphQL */ `query ListOfDriverTimePeriod(
  $sandbox_id: String!
  $sim_id: String!
  $costpool_ids: [String]
  $driver_id: String
) {
  ListOfDriverTimePeriod(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    costpool_ids: $costpool_ids
    driver_id: $driver_id
  )
}
` as GeneratedQuery<
  APITypes.ListOfDriverTimePeriodQueryVariables,
  APITypes.ListOfDriverTimePeriodQuery
>;
export const ListOfCustomDrivers = /* GraphQL */ `query ListOfCustomDrivers(
  $sandbox_id: String!
  $sim_id: String!
  $costpool_ids: [String]
  $userAlias: String
  $start: Int
  $limit: Int
  $group_by: CustomDriverGroupBy
) {
  ListOfCustomDrivers(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    costpool_ids: $costpool_ids
    userAlias: $userAlias
    start: $start
    limit: $limit
    group_by: $group_by
  ) {
    custom_driver_id
    custom_drivers {
      costpool_id
      timePeriod
      driver_id
      input_resource_key
      datasource_type
      __typename
    }
    custom_driver_count
    costpool_count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOfCustomDriversQueryVariables,
  APITypes.ListOfCustomDriversQuery
>;
export const ListPublishedSimulations = /* GraphQL */ `query ListPublishedSimulations(
  $sandbox_id: String
  $filter: SimBySandboxIdStatusFilterRequest
  $limit: Int
  $nextToken: String
) {
  ListPublishedSimulations(
    sandbox_id: $sandbox_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sandbox_id
      resource_key
      status_key
      resource_id
      resource_type
      is_active
      name
      status
      created_at
      updated_at
      started_at
      finished_at
      error_msg
      configs
      allocation_type
      input_ids
      mwaa_env
      dag_run_id
      scenario
      timeRange
      dag_tasks_status
      report_id
      is_shared
      userAlias
      created_by
      updated_by
      started_by
      is_input_selected
      published_to_fpaone
      fpaone_publish_status
      sandbox_name
      shared_to_sandbox_ids
      shared_from_sandbox_id
      shared_from_sandbox_name
      comments
      allocation_pools
      ticket_id
      simulation_tag
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPublishedSimulationsQueryVariables,
  APITypes.ListPublishedSimulationsQuery
>;
export const GetPublicURLForSimulationReport = /* GraphQL */ `query GetPublicURLForSimulationReport(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
) {
  GetPublicURLForSimulationReport(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    userAlias: $userAlias
  )
}
` as GeneratedQuery<
  APITypes.GetPublicURLForSimulationReportQueryVariables,
  APITypes.GetPublicURLForSimulationReportQuery
>;
export const GetMaxPeriodForDataSets = /* GraphQL */ `query GetMaxPeriodForDataSets($input: GetMaxPeriodForDataSetsInput) {
  GetMaxPeriodForDataSets(input: $input) {
    maxPeriodForDataSetList {
      dataSetName
      maxPeriod
      __typename
    }
    maxPeriodForDataSets
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMaxPeriodForDataSetsQueryVariables,
  APITypes.GetMaxPeriodForDataSetsQuery
>;
export const SearchByType = /* GraphQL */ `query SearchByType($query: String!, $searchType: SearchType!, $limit: Int) {
  SearchByType(query: $query, searchType: $searchType, limit: $limit) {
    results {
      id
      name
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchByTypeQueryVariables,
  APITypes.SearchByTypeQuery
>;
export const ListCostPools = /* GraphQL */ `query ListCostPools(
  $id: String!
  $name: String
  $type: CostPoolListType!
  $limit: Int
  $offset: Int
) {
  ListCostPools(
    id: $id
    name: $name
    type: $type
    limit: $limit
    offset: $offset
  ) {
    costPools {
      allocationPoolId
      allocationPoolName
      costCenters
      financeOwner
      lastUpdatedDate
      __typename
    }
    hasMore
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCostPoolsQueryVariables,
  APITypes.ListCostPoolsQuery
>;
export const GetCostPoolDetails = /* GraphQL */ `query GetCostPoolDetails($costPoolId: String!, $version: Int) {
  GetCostPoolDetails(costPoolId: $costPoolId, version: $version) {
    costPoolId
    version {
      id
      name
      __typename
    }
    definitions
    mappings
    driverDistribution
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCostPoolDetailsQueryVariables,
  APITypes.GetCostPoolDetailsQuery
>;
export const getConfiguration = /* GraphQL */ `query GetConfiguration($input: GetConfigurationRequest!) {
  getConfiguration(input: $input) {
    configs
    metadata
    user
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConfigurationQueryVariables,
  APITypes.GetConfigurationQuery
>;
export const getListOfTenants = /* GraphQL */ `query GetListOfTenants {
  getListOfTenants {
    tenants
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListOfTenantsQueryVariables,
  APITypes.GetListOfTenantsQuery
>;
export const getListOfConfigurations = /* GraphQL */ `query GetListOfConfigurations($input: GetListOfConfigsRequest!) {
  getListOfConfigurations(input: $input) {
    configs {
      configName
      configType
      parentConfig
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListOfConfigurationsQueryVariables,
  APITypes.GetListOfConfigurationsQuery
>;
export const retrieveConfigurations = /* GraphQL */ `query RetrieveConfigurations(
  $tenant: String!
  $configList: [RetrieveConfigListInput]
  $inheritFlag: Boolean
) {
  retrieveConfigurations(
    tenant: $tenant
    configList: $configList
    inheritFlag: $inheritFlag
  ) {
    configsMap {
      configName
      parentConfig
      configType
      configParams
      versionDescription
      metadata
      user
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RetrieveConfigurationsQueryVariables,
  APITypes.RetrieveConfigurationsQuery
>;
export const getListOfAccessibleTenants = /* GraphQL */ `query GetListOfAccessibleTenants($input: GetListOfAccessibleTenantsRequest!) {
  getListOfAccessibleTenants(input: $input) {
    tenants {
      tenantName
      operation
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetListOfAccessibleTenantsQueryVariables,
  APITypes.GetListOfAccessibleTenantsQuery
>;
export const GetSchema = /* GraphQL */ `query GetSchema($input: GetSchemaRequest) {
  GetSchema(input: $input) {
    attributeList {
      attributeName
      attributeLabel
      attributeType
      isRequired
      isDisabled
      isHidden
      defaultValue
      description
      options
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSchemaQueryVariables, APITypes.GetSchemaQuery>;
export const FetchExportedData = /* GraphQL */ `query FetchExportedData($input: FetchExportedDataRequest) {
  FetchExportedData(input: $input) {
    attributeList
    data
    status
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchExportedDataQueryVariables,
  APITypes.FetchExportedDataQuery
>;
export const FetchPreSignedUrl = /* GraphQL */ `query FetchPreSignedUrl($input: FetchPreSignedUrlRequest) {
  FetchPreSignedUrl(input: $input) {
    url
    inputID
    status
    message
    filePath
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchPreSignedUrlQueryVariables,
  APITypes.FetchPreSignedUrlQuery
>;
export const FetchDraftInputDetails = /* GraphQL */ `query FetchDraftInputDetails($input: FetchDraftInputDetailsRequest) {
  FetchDraftInputDetails(input: $input) {
    status
    errorAttributeList
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FetchDraftInputDetailsQueryVariables,
  APITypes.FetchDraftInputDetailsQuery
>;
export const DownloadErrorData = /* GraphQL */ `query DownloadErrorData($input: DownloadErrorDataRequest) {
  DownloadErrorData(input: $input) {
    url
    status
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DownloadErrorDataQueryVariables,
  APITypes.DownloadErrorDataQuery
>;
export const getGFTOneUserSubscription = /* GraphQL */ `query GetGFTOneUserSubscription($id: String!, $name: String) {
  getGFTOneUserSubscription(id: $id, name: $name) {
    id
    recipient
    app
    stage
    eventType
    resourceId
    channel
    createdOn
    lastModifiedOn
    expiresOn
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGFTOneUserSubscriptionQueryVariables,
  APITypes.GetGFTOneUserSubscriptionQuery
>;
export const getGFTOneUINotificationsCount = /* GraphQL */ `query GetGFTOneUINotificationsCount($input: GFTOneNotificationsInput) {
  getGFTOneUINotificationsCount(input: $input) {
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGFTOneUINotificationsCountQueryVariables,
  APITypes.GetGFTOneUINotificationsCountQuery
>;
export const getGFTOneUINotifications = /* GraphQL */ `query GetGFTOneUINotifications($input: GFTOneNotificationsInput) {
  getGFTOneUINotifications(input: $input) {
    items {
      id
      app
      channel
      alias
      created_at
      eventType
      stageSystemKey
      seen
      read
      sender
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGFTOneUINotificationsQueryVariables,
  APITypes.GetGFTOneUINotificationsQuery
>;
export const isMemberOfGroup = /* GraphQL */ `query IsMemberOfGroup($input: IsMemberOfGroupRequest!) {
  isMemberOfGroup(input: $input) {
    isMember
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsMemberOfGroupQueryVariables,
  APITypes.IsMemberOfGroupQuery
>;
export const isAuthorized = /* GraphQL */ `query IsAuthorized($input: IsAuthorizedBindleLockRequest!) {
  isAuthorized(input: $input) {
    isAuthorized
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsAuthorizedQueryVariables,
  APITypes.IsAuthorizedQuery
>;
export const canAccess = /* GraphQL */ `query CanAccess($input: CanAccessRequest!) {
  canAccess(input: $input) {
    isAuthorized
    status
    __typename
  }
}
` as GeneratedQuery<APITypes.CanAccessQueryVariables, APITypes.CanAccessQuery>;
export const checkPermission = /* GraphQL */ `query CheckPermission($input: CheckPermissionRequest!) {
  checkPermission(input: $input) {
    resourceList {
      operation
      namespace
      resourceType
      resourceName
      __typename
    }
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckPermissionQueryVariables,
  APITypes.CheckPermissionQuery
>;
export const checkPermissionBatch = /* GraphQL */ `query CheckPermissionBatch($input: CheckPermissionBatchRequest!) {
  checkPermissionBatch(input: $input) {
    resourceTypeList {
      resourceType
      __typename
    }
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckPermissionBatchQueryVariables,
  APITypes.CheckPermissionBatchQuery
>;
export const listMemberOfGroup = /* GraphQL */ `query ListMemberOfGroup($input: ListMemberOfGroupRequest!) {
  listMemberOfGroup(input: $input) {
    listOfMembers {
      actorID
      actorType
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMemberOfGroupQueryVariables,
  APITypes.ListMemberOfGroupQuery
>;
export const listBindleByOwner = /* GraphQL */ `query ListBindleByOwner($input: ListBindleByOwnerRequest!) {
  listBindleByOwner(input: $input) {
    listOfBindles {
      bindleID
      bindleName
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBindleByOwnerQueryVariables,
  APITypes.ListBindleByOwnerQuery
>;
export const getFpaoneProductsCatalog = /* GraphQL */ `query GetFpaoneProductsCatalog($productId: String!, $category: String!) {
  getFpaoneProductsCatalog(productId: $productId, category: $category) {
    category
    productId
    subCategory
    url
    description
    name
    wiki
    productType
    status
    accessGroups
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFpaoneProductsCatalogQueryVariables,
  APITypes.GetFpaoneProductsCatalogQuery
>;
export const listFpaoneProductsCatalogs = /* GraphQL */ `query ListFpaoneProductsCatalogs {
  listFpaoneProductsCatalogs {
    items {
      category
      productId
      subCategory
      url
      description
      name
      wiki
      productType
      status
      accessGroups
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFpaoneProductsCatalogsQueryVariables,
  APITypes.ListFpaoneProductsCatalogsQuery
>;
export const getUserWorkspaceDetails = /* GraphQL */ `query GetUserWorkspaceDetails($userId: String!) {
  getUserWorkspaceDetails(userId: $userId) {
    userId
    productIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserWorkspaceDetailsQueryVariables,
  APITypes.GetUserWorkspaceDetailsQuery
>;
export const listUserWorkspaceDetails = /* GraphQL */ `query ListUserWorkspaceDetails(
  $filter: TableUserWorkspaceDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserWorkspaceDetails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      userId
      productIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserWorkspaceDetailsQueryVariables,
  APITypes.ListUserWorkspaceDetailsQuery
>;
export const getGMUnitLockSummary = /* GraphQL */ `query GetGMUnitLockSummary {
  getGMUnitLockSummary {
    accountName
    lockStatus
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGMUnitLockSummaryQueryVariables,
  APITypes.GetGMUnitLockSummaryQuery
>;
export const getAllCategories = /* GraphQL */ `query GetAllCategories {
  getAllCategories {
    categoryId
    categoryName
    subcategories {
      subCategoryId
      subCategoryName
      parentCategoryId
      status
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllCategoriesQueryVariables,
  APITypes.GetAllCategoriesQuery
>;
export const getAllProducts = /* GraphQL */ `query GetAllProducts($productIds: [ID], $aliases: [String]) {
  getAllProducts(productIds: $productIds, aliases: $aliases) {
    productId
    name
    description
    info
    alias
    subCategoryId
    subCategoryName
    categoryId
    categoryName
    status
    productType
    accessGroups
    ownerGroups
    QUICKSIGHT_DASHBOARD {
      accountId
      namespace
      dashboardId
      props
      __typename
    }
    APLIQO_DASHBOARD {
      url
      props
      __typename
    }
    MICRO_FRONTEND {
      filePath
      exportApp
      props
      __typename
    }
    NATIVE_EXTERNAL {
      url
      props
      __typename
    }
    NATIVE_INTERNAL {
      name
      props
      __typename
    }
    accessType
    fintalkEnabled
    fintalkProps
    requestAccessLink
    featured
    wiki
    poc
    ticketConfig {
      category
      type
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllProductsQueryVariables,
  APITypes.GetAllProductsQuery
>;
export const getProductsByCategory = /* GraphQL */ `query GetProductsByCategory($categoryId: ID!) {
  getProductsByCategory(categoryId: $categoryId) {
    productId
    name
    description
    info
    alias
    subCategoryId
    subCategoryName
    categoryId
    categoryName
    status
    productType
    accessGroups
    ownerGroups
    QUICKSIGHT_DASHBOARD {
      accountId
      namespace
      dashboardId
      props
      __typename
    }
    APLIQO_DASHBOARD {
      url
      props
      __typename
    }
    MICRO_FRONTEND {
      filePath
      exportApp
      props
      __typename
    }
    NATIVE_EXTERNAL {
      url
      props
      __typename
    }
    NATIVE_INTERNAL {
      name
      props
      __typename
    }
    accessType
    fintalkEnabled
    fintalkProps
    requestAccessLink
    featured
    wiki
    poc
    ticketConfig {
      category
      type
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductsByCategoryQueryVariables,
  APITypes.GetProductsByCategoryQuery
>;
export const getQuicksightDashboardUrl = /* GraphQL */ `query GetQuicksightDashboardUrl(
  $productId: ID!
  $dashboardId: String
  $accountId: String
  $namespace: String
) {
  getQuicksightDashboardUrl(
    productId: $productId
    dashboardId: $dashboardId
    accountId: $accountId
    namespace: $namespace
  ) {
    quicksightUrl
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuicksightDashboardUrlQueryVariables,
  APITypes.GetQuicksightDashboardUrlQuery
>;
export const getAllSections = /* GraphQL */ `query GetAllSections {
  getAllSections {
    sectionId
    sectionName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    subsections {
      subsectionId
      subsectionName
      description
      wikiLink
      contentURL
      parentSectionId
      status
      sortOrder
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAllSectionsQueryVariables,
  APITypes.GetAllSectionsQuery
>;
export const getSectionById = /* GraphQL */ `query GetSectionById($sectionId: ID!) {
  getSectionById(sectionId: $sectionId) {
    sectionId
    sectionName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    subsections {
      subsectionId
      subsectionName
      description
      wikiLink
      contentURL
      parentSectionId
      status
      sortOrder
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSectionByIdQueryVariables,
  APITypes.GetSectionByIdQuery
>;
export const getSubsections = /* GraphQL */ `query GetSubsections($sectionId: ID!) {
  getSubsections(sectionId: $sectionId) {
    subsectionId
    subsectionName
    description
    wikiLink
    contentURL
    parentSectionId
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubsectionsQueryVariables,
  APITypes.GetSubsectionsQuery
>;
export const getAboutFPAOne = /* GraphQL */ `query GetAboutFPAOne {
  getAboutFPAOne {
    aboutId
    about
    poc
    accessGroups
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAboutFPAOneQueryVariables,
  APITypes.GetAboutFPAOneQuery
>;
export const getUserRoles = /* GraphQL */ `query GetUserRoles {
  getUserRoles {
    roles
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserRolesQueryVariables,
  APITypes.GetUserRolesQuery
>;
export const listTicketCategories = /* GraphQL */ `query ListTicketCategories {
  listTicketCategories {
    id
    label
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTicketCategoriesQueryVariables,
  APITypes.ListTicketCategoriesQuery
>;
export const listTicketTypes = /* GraphQL */ `query ListTicketTypes($category: String!) {
  listTicketTypes(category: $category) {
    id
    label
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTicketTypesQueryVariables,
  APITypes.ListTicketTypesQuery
>;
export const listTicketItems = /* GraphQL */ `query ListTicketItems($category: String!, $type: String!) {
  listTicketItems(category: $category, type: $type) {
    id
    label
    name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTicketItemsQueryVariables,
  APITypes.ListTicketItemsQuery
>;
export const getUserGroups = /* GraphQL */ `query GetUserGroups($userId: String!, $applicationId: ApplicationId) {
  getUserGroups(userId: $userId, applicationId: $applicationId) {
    ldapGroups
    antGroups
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserGroupsQueryVariables,
  APITypes.GetUserGroupsQuery
>;
export const queryModularTable = /* GraphQL */ `query QueryModularTable(
  $tableName: String!
  $columns: [String!]!
  $filters: AWSJSON
  $limit: Int
  $resolveGuid: Boolean
  $distinct: Boolean
  $datasetNames: [String!]
  $scenario: String
) {
  queryModularTable(
    tableName: $tableName
    columns: $columns
    filters: $filters
    limit: $limit
    resolveGuid: $resolveGuid
    distinct: $distinct
    datasetNames: $datasetNames
    scenario: $scenario
  ) {
    success
    data
    queryExecutionId
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.QueryModularTableQueryVariables,
  APITypes.QueryModularTableQuery
>;
export const getRunInfoLog = /* GraphQL */ `query GetRunInfoLog($runId: String!, $process: String!) {
  getRunInfoLog(runId: $runId, process: $process) {
    success
    lines {
      timestamp
      level
      message
      __typename
    }
    lastUpdated
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRunInfoLogQueryVariables,
  APITypes.GetRunInfoLogQuery
>;
export const getCsvFromS3 = /* GraphQL */ `query GetCsvFromS3($bucket: String!, $keyPrefix: String!) {
  getCsvFromS3(bucket: $bucket, keyPrefix: $keyPrefix) {
    success
    columns
    rows
    lastUpdated
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCsvFromS3QueryVariables,
  APITypes.GetCsvFromS3Query
>;
export const runQuery = /* GraphQL */ `query RunQuery($sql: String!, $maxRows: Int) {
  runQuery(sql: $sql, maxRows: $maxRows) {
    success
    data
    error
    __typename
  }
}
` as GeneratedQuery<APITypes.RunQueryQueryVariables, APITypes.RunQueryQuery>;
export const getRunLineage = /* GraphQL */ `query GetRunLineage(
  $runId: String!
  $targetTable: String!
  $outputTable: String
  $datasetKey: String
) {
  getRunLineage(
    runId: $runId
    targetTable: $targetTable
    outputTable: $outputTable
    datasetKey: $datasetKey
  ) {
    success
    pairs
    producer
    apiUrl
    tableName
    datasetName
    datasetMismatch
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRunLineageQueryVariables,
  APITypes.GetRunLineageQuery
>;
export const getTableSchema = /* GraphQL */ `query GetTableSchema($tableName: String!) {
  getTableSchema(tableName: $tableName) {
    success
    data {
      columnName
      dataType
      comment
      __typename
    }
    tableName
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTableSchemaQueryVariables,
  APITypes.GetTableSchemaQuery
>;
export const getLatestGuid = /* GraphQL */ `query GetLatestGuid($datasetName: String!) {
  getLatestGuid(datasetName: $datasetName) {
    success
    guid
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLatestGuidQueryVariables,
  APITypes.GetLatestGuidQuery
>;
export const getGuidPeriodPairs = /* GraphQL */ `query GetGuidPeriodPairs($datasetName: String!, $scenario: String) {
  getGuidPeriodPairs(datasetName: $datasetName, scenario: $scenario) {
    success
    pairs {
      guid
      period
      s3Location
      __typename
    }
    truncated
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGuidPeriodPairsQueryVariables,
  APITypes.GetGuidPeriodPairsQuery
>;
export const checkPartitionsHaveFiles = /* GraphQL */ `query CheckPartitionsHaveFiles(
  $datasetName: String!
  $scenario: String
  $periods: [String!]!
  $tableName: String
) {
  checkPartitionsHaveFiles(
    datasetName: $datasetName
    scenario: $scenario
    periods: $periods
    tableName: $tableName
  ) {
    success
    results {
      period
      hasFiles
      error
      __typename
    }
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckPartitionsHaveFilesQueryVariables,
  APITypes.CheckPartitionsHaveFilesQuery
>;
export const getDataHealth = /* GraphQL */ `query GetDataHealth(
  $datasetName: String!
  $scenario: String
  $startPeriod: String!
  $endPeriod: String!
) {
  getDataHealth(
    datasetName: $datasetName
    scenario: $scenario
    startPeriod: $startPeriod
    endPeriod: $endPeriod
  ) {
    success
    lastSweptAt
    entries {
      period
      verdict
      __typename
    }
    minPeriod
    maxPeriod
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataHealthQueryVariables,
  APITypes.GetDataHealthQuery
>;
export const getQueryStatus = /* GraphQL */ `query GetQueryStatus($queryExecutionId: String!) {
  getQueryStatus(queryExecutionId: $queryExecutionId) {
    success
    queryExecutionId
    status
    dataScannedBytes
    engineExecutionTimeMillis
    totalExecutionTimeMillis
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryStatusQueryVariables,
  APITypes.GetQueryStatusQuery
>;
export const getQueryResults = /* GraphQL */ `query GetQueryResults(
  $queryExecutionId: String!
  $nextToken: String
  $pageSize: Int
) {
  getQueryResults(
    queryExecutionId: $queryExecutionId
    nextToken: $nextToken
    pageSize: $pageSize
  ) {
    success
    data
    queryExecutionId
    nextToken
    hasNextPage
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQueryResultsQueryVariables,
  APITypes.GetQueryResultsQuery
>;
export const getRecord = /* GraphQL */ `query GetRecord($input: GetRecordInput!) {
  getRecord(input: $input) {
    success
    message
    data
    tableName
    recordId
    error
    notificationsPublished
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRecordQueryVariables, APITypes.GetRecordQuery>;
export const listRecords = /* GraphQL */ `query ListRecords($input: ListRecordsInput!) {
  listRecords(input: $input) {
    success
    data
    tableName
    totalCount
    nextToken
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordsQueryVariables,
  APITypes.ListRecordsQuery
>;
export const getDependencyData = /* GraphQL */ `query GetDependencyData($input: GetDependencyDataInput!) {
  getDependencyData(input: $input) {
    success
    data
    tableName
    dependencyTable
    runId
    guid
    mode
    queryExecutionId
    pagination {
      hasNextPage
      totalCount
      pageSize
      currentPage
      __typename
    }
    nextToken
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDependencyDataQueryVariables,
  APITypes.GetDependencyDataQuery
>;
export const getChartData = /* GraphQL */ `query GetChartData($input: GetChartDataInput!) {
  getChartData(input: $input) {
    success
    forecast
    actuals
    forecastQueryId
    actualsQueryId
    error
    errorCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChartDataQueryVariables,
  APITypes.GetChartDataQuery
>;
export const getChartFilters = /* GraphQL */ `query GetChartFilters($input: GetChartFiltersInput!) {
  getChartFilters(input: $input) {
    success
    filterValues
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChartFiltersQueryVariables,
  APITypes.GetChartFiltersQuery
>;
export const getActualsTimeseries = /* GraphQL */ `query GetActualsTimeseries($input: GetActualsTimeseriesInput!) {
  getActualsTimeseries(input: $input) {
    success
    rows
    queryId
    minPeriod
    maxPeriod
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActualsTimeseriesQueryVariables,
  APITypes.GetActualsTimeseriesQuery
>;
export const getActualsDistinctValues = /* GraphQL */ `query GetActualsDistinctValues($input: GetActualsDistinctValuesInput!) {
  getActualsDistinctValues(input: $input) {
    success
    filterValues
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetActualsDistinctValuesQueryVariables,
  APITypes.GetActualsDistinctValuesQuery
>;
export const checkActualsMembership = /* GraphQL */ `query CheckActualsMembership($input: CheckActualsMembershipInput!) {
  checkActualsMembership(input: $input) {
    success
    inData
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CheckActualsMembershipQueryVariables,
  APITypes.CheckActualsMembershipQuery
>;
export const getHierarchyDescendants = /* GraphQL */ `query GetHierarchyDescendants($input: GetHierarchyDescendantsInput!) {
  getHierarchyDescendants(input: $input) {
    success
    descendants
    encoding
    idToName
    idToNameEncoding
    status
    queryExecutionId
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHierarchyDescendantsQueryVariables,
  APITypes.GetHierarchyDescendantsQuery
>;
export const getHierarchyTopologyStatus = /* GraphQL */ `query GetHierarchyTopologyStatus($input: GetHierarchyTopologyStatusInput!) {
  getHierarchyTopologyStatus(input: $input) {
    success
    descendants
    encoding
    idToName
    idToNameEncoding
    status
    queryExecutionId
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHierarchyTopologyStatusQueryVariables,
  APITypes.GetHierarchyTopologyStatusQuery
>;
export const searchDimSumNodes = /* GraphQL */ `query SearchDimSumNodes($input: SearchDimSumNodesInput!) {
  searchDimSumNodes(input: $input) {
    nodes {
      id
      nodeID
      name
      description
      keyFull
      __typename
    }
    total
    hasMore
    parentNodes {
      id
      nodeID
      name
      description
      keyFull
      __typename
    }
    enabled
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchDimSumNodesQueryVariables,
  APITypes.SearchDimSumNodesQuery
>;
export const getDimSumRoots = /* GraphQL */ `query GetDimSumRoots($dimensionID: String!) {
  getDimSumRoots(dimensionID: $dimensionID) {
    nodes {
      id
      nodeID
      name
      description
      keyFull
      __typename
    }
    enabled
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDimSumRootsQueryVariables,
  APITypes.GetDimSumRootsQuery
>;
export const getDimSumChildren = /* GraphQL */ `query GetDimSumChildren($input: GetDimSumChildrenInput!) {
  getDimSumChildren(input: $input) {
    nodes {
      id
      nodeID
      name
      description
      keyFull
      __typename
    }
    total
    hasMore
    parentNodes {
      id
      nodeID
      name
      description
      keyFull
      __typename
    }
    enabled
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDimSumChildrenQueryVariables,
  APITypes.GetDimSumChildrenQuery
>;
export const getDdbExportStatus = /* GraphQL */ `query GetDdbExportStatus($taskId: String!) {
  getDdbExportStatus(taskId: $taskId) {
    success
    taskId
    status
    rowsWritten
    completedAt
    startedAt
    targetTableName
    error
    errorCode
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDdbExportStatusQueryVariables,
  APITypes.GetDdbExportStatusQuery
>;
export const listInProgressExports = /* GraphQL */ `query ListInProgressExports($targetTableName: String!) {
  listInProgressExports(targetTableName: $targetTableName) {
    success
    tasks {
      taskId
      targetTableName
      status
      startedAt
      lastUpdatedAt
      rowsWritten
      __typename
    }
    error
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInProgressExportsQueryVariables,
  APITypes.ListInProgressExportsQuery
>;
